import React from "react";

function SellersComponent() {
  let categoryIframeUrl =  `https://dev.d34ok3vur1b75a.amplifyapp.com/sellers`;

  return (
    <>
      <div>
        {/* begin component */}
        <div className="toolbar" id="kt_toolbar">
          {/*begin::Container*/}
          <div id="kt_toolbar_container" className="container-fluid d-flex flex-stack">
            <iframe src={categoryIframeUrl} style={{width: "100%",height: "100vh"}}></iframe>
          </div>
          {/*end::Container*/}
        </div>
        {/*end::Toolbar*/}
        {/*begin::Container*/}

      </div>
    </>
  );
}

export default SellersComponent;
